import configs from './config.json';
import {Api} from "./Api";

export class UserApi {
    static dispatcher = null;
    static login = async (data, response, error) => {
        // Api.d();
        await Api.post(`${configs.user.login}`, data, response, configs.requestHeader, error);
    }

    static check = async (response, error) => {

        await Api.post(configs.user.check, {}, response, this.getAuthorizedHeader(), error);

    }

    static getAuthorizedHeader = () => {
        return {
            ...configs.requestHeader,
            Authorization: `bearer ${localStorage.getItem('token')}`
        };
    }

    static verifyPhone = (data, response) => {
        Api.getInstance().post(`${configs.server.Api}/${configs.user.verifyPhone}`, data, response);

    }
    static logout = async (response, error) => {
        await Api.post(`${configs.user.logout}`, {}, response, this.getAuthorizedHeader(), error);

    }

    static getAllUser = async (data,response, error) => {
        await Api.get(`${configs.user.user}`, null, response, this.getAuthorizedHeader(), error);
    }



    static activateUser = async (data, response, error) => {
        await Api.post(`${configs.user.activate}/${data}`, {}, response, this.getAuthorizedHeader(), error);
    }

    static deactivateUser = async (data, response, error) => {
        await Api.post(`${configs.user.deactivate}/${data}`, {}, response, this.getAuthorizedHeader(), error);
    }
    static getUserById = async (data, response, error) => {
        await Api.get(`${configs.user.user}/${data}`, null, response, this.getAuthorizedHeader(), error);
    }

    static updateUser = async (data, userId, response, error) => {
        await Api.put(`${configs.user.user}/${userId}`, data, response, UserApi.getAuthorizedHeader(), error);
    }

    static updateUserPassword = async (data, userId, response, error) => {
        await Api.post(`${configs.user.password}/${userId}`, data, response, UserApi.getAuthorizedHeader(), error);
    }
    static updateMyPassword = async (data, response, error) => {
        await Api.post(`${configs.user.password}`, data, response, UserApi.getAuthorizedHeader(), error);
    }

    static getRoles = async (response, error) => {
        await Api.get(`${configs.user.getRoles}`, '', response, this.getAuthorizedHeader(), error);
    }

    static insertNewUser = async (data, response, error) => {
        await Api.post(`${configs.user.user}`, data, response, this.getAuthorizedHeader(), error);
    }


}
